export const ALWAYS_BACKUP_AT_STARTUP: boolean        = false;
export const ALWAYS_VERIFY_AT_STARTUP: boolean        = false;
export const FAKE_TIME_SKEW_ERROR: boolean            = false;
export const TRACE_CALL_BACKEND: boolean              = false;
export const TRACE_CYPHER: boolean                    = false;
export const TRACE_CYPHER_TIMING: boolean             = false;
export const TRACE_EXPRESSIONS: boolean               = false;
export const TRACE_MONITOR_ADJUST_STATUS: boolean     = false;
export const TRACE_MONITOR_CALCULATION: boolean       = false;
export const TRACE_MONITOR_SYNC_REPORT_ITEMS: boolean = false;
export const TRACE_NEO4J_UPDATER: boolean             = false;
export const TRACE_TX_HOLDER: boolean                 = false;
export const TRACE_HANDLE_REPORT: boolean             = false;
export const TRACE_WAITING_TIMES: boolean             = false;
export const TRACE_WAITING_TIMES_VERBOSE: boolean     = false;
export const PROTECT_ACCEPTED_ITEMS: boolean          = false;
export const TRACE_CRON: boolean                      = false;
export const TRACE_CACHE: boolean                     = false;
